module.exports = __webpack_public_path__ + "static/flags/LS-e61ad3aec473101e81664f62817cbbea.gif";